module.exports = __webpack_public_path__ + "assets/img/downsample.b855c75d.svg";